import { render, staticRenderFns } from "./TableFormFields.vue?vue&type=template&id=121a7a32&scoped=true"
import script from "./TableFormFields.vue?vue&type=script&lang=js"
export * from "./TableFormFields.vue?vue&type=script&lang=js"
import style0 from "./TableFormFields.vue?vue&type=style&index=0&id=121a7a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a7a32",
  null
  
)

export default component.exports